module.exports = __webpack_public_path__ + "img/teletravail_formation.dab76c7c.jpg";